import React from 'react';
import * as subscriptionTypes from 'state/subscription/SubscriptionTypes';
import styled from 'styled-components';
import AppleLogo from 'components/Icons/AppleLogo';
import StripeLogo from 'components/Icons/StripeLogo';
import GoogleLogo from 'components/Icons/GoogleLogo';
import Label from 'components/Label';
import { convertTimeStamp } from 'utils';
import { RFC } from 'state/StateTypes';
import SmallLoader from 'components/SmallLoader';

interface Props {
   subscription: subscriptionTypes.Subscription;
   margin?: string;
   isUpdating?: boolean;
}

const Subscription: RFC<Props> = ({ subscription, margin, isUpdating = true }) => (
   <Container margin={margin}>
      <Detail>
         <DetailLabel>Tier</DetailLabel>
         <span>{subscription.tier}</span>
      </Detail>
      <Detail>
         <DetailLabel>Type</DetailLabel>
         <TypeSpan>
            {subscription.paymentProvider && determineLogo(subscription.paymentProvider)} {subscription.paymentProvider}
         </TypeSpan>
      </Detail>
      <Detail>
         <DetailLabel>Expiration Date</DetailLabel>
         <span>{isUpdating ? <SmallLoader /> : convertTimeStamp(subscription.expirationDate)}</span>
      </Detail>
   </Container>
);

export default Subscription;

function determineLogo(subscriptionType: subscriptionTypes.SubscriptionProviders): JSX.Element {
   if (subscriptionType === subscriptionTypes.SubscriptionProviders.Apple) {
      return <AppleLogo />;
   } else if (subscriptionType === subscriptionTypes.SubscriptionProviders.Google) {
      return <GoogleLogo />;
   } else {
      return <StripeLogo />;
   }
}

const Container = styled.div<{ margin?: string }>`
   text-align: left;
   padding: 15px 20px;
   background-color: ${({ theme }) => theme.secondaryWhite};
   border: 1px solid ${({ theme }) => theme.primaryGrey};
   border-radius: 7px;
   margin: ${({ margin = '1em auto 20px auto' }) => margin};
   display: flex;
   justify-content: space-between;
   align-items: center;
   color: #000;

   > * {
      margin: 0 10px;
   }

   @media only screen and (max-width: 630px) {
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
   }
`;

const Detail = styled.div`
   display: flex;
   flex-direction: row;
   justify-content: center;
   align-items: center;
`;

const DetailLabel = styled(Label)``;

const TypeSpan = styled.span`
   display: flex;
   flex-direction: row;
   justify-content: center;
   align-items: center;
   > * {
      margin: 0 5px;
   }
`;
